import Image from '~/components/Image';
import NonLoginShoppingCartButton from '~/components/NonLogin/NonLoginShoppingCartButton';
import { useCurrentUser } from '~/domains/auth/queries';
import ShoppingCartButton from '~/domains/cart/ShoppingCartButton';
import DeliveryFlag from '~/domains/delivery/DeliveryFlag';
import PlusMembershipProductBadge from '~/domains/plusMembership/components/PlusMembershipProductBadge';
import { useTrackProductEventProps } from '~/hooks/event';
import { useLinkComponent } from '~/hooks/mobileApp';
import type { OAISchema } from '~/types/openapi';

import ProductPrice from '../components/ProductPrice';
import ProductSalesTargetBadge from '../components/ProductSalesTargetBadge';

import styles from './ProductDisplayItem.module.css';

type Props = {
  product: OAISchema['MarketSelectProductResponseV2'];
  eventOption?: Record<string, unknown>;
  plusMembershipFullBadge?: boolean;
  reverseCouponDiscountedPrice?: boolean;
};

const ProductDisplayItem = ({
  product,
  eventOption,
  plusMembershipFullBadge = false,
  reverseCouponDiscountedPrice,
}: Props) => {
  const { isLoggedIn } = useCurrentUser();
  const [{ onClick, trackAddCart }] = useTrackProductEventProps(
    product,
    eventOption,
  );
  const LinkComponent = useLinkComponent();

  const onClickProduct = () => {
    onClick?.();
  };

  const onClickCart = () => {
    trackAddCart?.();
  };

  return (
    <div className={styles.wrap}>
      <div
        className={styles.mainImage}
        role="presentation"
        onClick={onClickProduct}
      >
        <LinkComponent
          href={`/vendors/${product.vendorId}/products/${product.offerId!}`}
        >
          <Image width={92} height={92} alt="" src={product.mainImages![0]} />
        </LinkComponent>
      </div>
      <LinkComponent
        href={`/vendors/${product.vendorId}/products/${product.offerId!}`}
        className={styles.productInfo}
      >
        <div
          className="flex flex-col"
          role="presentation"
          onClick={onClickProduct}
        >
          <div>
            <ProductSalesTargetBadge
              salesTargets={product.salesTargets}
              className="mb-6"
              full={plusMembershipFullBadge}
            />
          </div>
          <p className={styles.productName}>{product.productName}</p>
          {product.promotionText && (
            <p className={styles.promotionText}>{product.promotionText}</p>
          )}
          <PlusMembershipProductBadge salesTargets={product.salesTargets} />
          <ProductPrice
            {...product}
            reverse={reverseCouponDiscountedPrice}
            wFull={false}
          />
          <DeliveryFlag flags={product.deliveryFlags} />
        </div>
      </LinkComponent>
      <div className={styles.cartItem}>
        {isLoggedIn ? (
          <ShoppingCartButton item={product} onClick={onClickCart} />
        ) : (
          <NonLoginShoppingCartButton className="mb-0 mr-0" />
        )}
      </div>
    </div>
  );
};

export default ProductDisplayItem;
